export default "__VITE_ASSET__5vTt4PAI__"